export function focusCena(e, to, from) {
    const el = $(e.currentTarget);
    const index = el.data(from); //param1
    this.$nextTick(() => {
        $(`[${to}="${index}"]`).focus() //param2
    })
}